import * as yup from 'yup';
import {
  nullableNumber,
  nullableString,
  positiveCurrencyIncludingZeroValidation,
  percentageValidation,
} from 'utils/form/validation';
import { FIELDS } from 'modules/cm/fields/types';
import { FuturePension } from 'modules/cm/pages/CaseDetailsPage/CaseDetailsPage.types';

type DefinedBenefit = FuturePension[FIELDS.FUTURE_PENSION_DEFINED_BENEFITS_PREFIX][0];
type DefinedContribution = FuturePension[FIELDS.FUTURE_PENSION_DEFINED_CONTRIBUTIONS_PREFIX][0];
type FutureAnnuity = FuturePension[FIELDS.FUTURE_ANNUITY_PREFIX][0];

export default yup.object().shape<FuturePension>({
  [FIELDS.FUTURE_STATE_PENSION]: nullableNumber(),
  [FIELDS.FUTURE_PENSION_DEFINED_BENEFITS_PREFIX]: yup.array().of<DefinedBenefit>(
    yup.object().shape({
      id: yup.number(),
      [FIELDS.NAME_OF_SCHEME]: nullableString(),
      [FIELDS.ANNUAL_INCOME]: positiveCurrencyIncludingZeroValidation(),
      [FIELDS.START_DATE]: nullableString(),
      [FIELDS.PERCENTAGE_VALUE_OF_PASSED_ON_DEATH]: nullableNumber(),
      [FIELDS.FUTURE_PENSION_REPAYMENT_LUMP_SUM]: nullableNumber(),
    }),
  ),
  [FIELDS.FUTURE_PENSION_DEFINED_CONTRIBUTIONS_PREFIX]: yup.array().of<DefinedContribution>(
    yup.object().shape({
      id: yup.number(),
      [FIELDS.NAME_OF_SCHEME]: nullableString(),
      [FIELDS.CURRENT_VALUE]: positiveCurrencyIncludingZeroValidation(),
      [FIELDS.START_DATE]: nullableString(),
      [FIELDS.ONGOING_MONTHLY_CONTRIBUTIONS]: nullableNumber(),
      [FIELDS.PERCENTAGE_VALUE_OF_PASSED_ON_DEATH]: nullableNumber(),
      [FIELDS.FUTURE_ANNUAL_INCOME_DRAWN]: nullableNumber(),
      [FIELDS.USE_OF_FUND]: nullableString(),
    }),
  ),
  [FIELDS.FUTURE_ANNUITY_PREFIX]: yup.array().of<FutureAnnuity>(
    yup.object().shape({
      id: yup.number(),
      [FIELDS.FUTURE_ANNUITY_NAME_OF_ANNUITY_PROVIDER]: nullableString(),
      [FIELDS.FUTURE_ANNUITY_GROSS_ANNUAL_INCOME]: positiveCurrencyIncludingZeroValidation(),
      [FIELDS.FUTURE_ANNUITY_PERCENT_PASSED_ON_DEATH]: percentageValidation(),
    }),
  ),
  [FIELDS.LUMP_SUM_DRAWDOWN]: nullableNumber(),
  [FIELDS.REPAYMENT_LUMP_SUM]: nullableNumber(),
});
